// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5jwoe","tabsBox":"styles_tabsBox__rVP93","createButton":"styles_createButton__1Ze6L"};